import {ProductOptionType} from '@wix/wixstores-graphql-schema';
import {IProduct, IProductOption, ProductOptionsDisplayOption} from '../types/galleryTypes';
import {hasSubscriptionPlans} from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';

export function hasBlockingFeatures(product: IProduct): boolean {
  return hasSubscriptionPlans(product) || product.customTextFields?.length > 0;
}

export function supportsDirectAddToCartFromGallery({
  options,
  isProductOptionsEnabled,
  isShowOnlyColorOptionsEnabled,
  productOptionsDisplayOption,
  isShowFirstProductOptionInGalleryExperimentEnabled,
}: {
  options: IProductOption[];
  isProductOptionsEnabled: boolean;
  isShowOnlyColorOptionsEnabled: boolean;
  productOptionsDisplayOption: ProductOptionsDisplayOption;
  isShowFirstProductOptionInGalleryExperimentEnabled: boolean;
}): boolean {
  const numberOfOptions = options.length;
  const numberOfColorOptions = options.filter((option) => option.optionType === ProductOptionType.COLOR).length;

  if (numberOfOptions === 0) {
    return true;
  }

  const hasLessThanThreeOptions = numberOfOptions < 3;
  const hasLessThanTwoColorOptions = numberOfColorOptions < 2;
  const hasNonColorOption = numberOfColorOptions !== numberOfOptions;

  const hasNonColorOptionsAndColorOptionsOnlyEnabled = !isShowFirstProductOptionInGalleryExperimentEnabled
    ? isShowOnlyColorOptionsEnabled && hasNonColorOption
    : productOptionsDisplayOption === ProductOptionsDisplayOption.FIRST_COLOR && hasNonColorOption;

  const isFirstOptionAnyTypeDisplayed =
    isShowFirstProductOptionInGalleryExperimentEnabled &&
    productOptionsDisplayOption === ProductOptionsDisplayOption.FIRST_ANY_OPTION
      ? numberOfOptions === 1
      : true;

  return (
    isProductOptionsEnabled &&
    hasLessThanThreeOptions &&
    hasLessThanTwoColorOptions &&
    !hasNonColorOptionsAndColorOptionsOnlyEnabled &&
    isFirstOptionAnyTypeDisplayed
  );
}
